/**
 * @file The enumerator is used to configure components.
 * @author Tom Verschoore de la Houssaije
 */
/** The enumerator is used to configure components. */
export var DataRights;
(function (DataRights) {
    /** Component has (minimal) read rights. */
    DataRights[DataRights["Read"] = 1] = "Read";
    /** Component has create rights. */
    DataRights[DataRights["Create"] = 2] = "Create";
    /** Component has update rights. */
    DataRights[DataRights["Update"] = 4] = "Update";
    /** Component has delete rights. */
    DataRights[DataRights["Delete"] = 8] = "Delete";
})(DataRights || (DataRights = {}));
